require("./bootstrap");

import Vue from 'vue'

import './plugins'
import router from "./router";
import store from "./store";

import vSelect from 'vue-select'
Vue.component('v-select', vSelect)

import App from "./App.vue";
Vue.component("app", App);

import AppHeader from "./components/core/AppHeader";
Vue.component("app-header", AppHeader)

import flatPickr from 'vue-flatpickr-component'
Vue.component("flat-pickr", flatPickr)

import vue2Dropzone from "vue2-dropzone";
Vue.component('vue-dropzone', vue2Dropzone)

Vue.filter('prettydate', date => moment(date).format('DD/MM/YYYY'))
Vue.filter('prettyhour', hour => hour.substring(0, 5))
Vue.filter('ellipsis', text => text ? text.trim().substring(0, 100) + '...' : '')

new Vue({
    router,
    store,
    el: "#app"
});
